/**
 * Clears `_modal` / `_modals` on the current history entry so `useModal`'s
 * unmount cleanup will not call `history.goBack()`.
 *
 * Needed when a full-page navigation (reload / location assign) is about to
 * start: `goBack()` would cancel that document request. Same contract as
 * `openCopilotFromModal`.
 */
const stripModalHistoryMarkers = (): void => {
  if (typeof window === "undefined" || !window.history?.state) {
    return;
  }

  const cleanedState = { ...window.history.state };
  delete cleanedState._modal;
  delete cleanedState._modals;
  // connected-react-router nests state inside a `state` key
  if (cleanedState.state && typeof cleanedState.state === "object") {
    cleanedState.state = { ...cleanedState.state };
    delete cleanedState.state._modal;
    delete cleanedState.state._modals;
  }
  window.history.replaceState(cleanedState, "", window.location.href);
};

export default stripModalHistoryMarkers;
